import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import state from './state';
import app from './modules/app';
import permission from './modules/permissions';
import user from './modules/user';
import getters from './getters.js';
import actions from './actions.js';
export default new Vuex.Store({
    modules:{
        app,
        user,
        permission
    },
    state,
    getters,
    actions
});


// WEBPACK FOOTER //
// ./src/other/store/index.js